import { render, staticRenderFns } from "./Readinglist.vue?vue&type=template&id=11607905&scoped=true&"
import script from "./Readinglist.vue?vue&type=script&lang=js&"
export * from "./Readinglist.vue?vue&type=script&lang=js&"
import style0 from "./Readinglist.vue?vue&type=style&index=0&id=11607905&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11607905",
  null
  
)

export default component.exports